import { Star } from "lucide-react";

export default function ReviewCard({ review, index = 0 }) {
  return (
    <figure
      className="flex h-full flex-col justify-between border border-brand-ink/12 bg-white p-7 md:p-8 transition-colors duration-300 hover:border-brand-red"
      data-testid={`review-card-${index}`}
    >
      <div>
        <div className="flex gap-1 mb-5" aria-label={`${review.rating} out of 5 stars`}>
          {Array.from({ length: 5 }).map((_, i) => (
            <Star
              key={i}
              size={16}
              className={i < review.rating ? "fill-brand-gold text-brand-gold" : "text-brand-ink/20"}
            />
          ))}
        </div>
        <blockquote className="font-display text-lg md:text-xl leading-relaxed text-brand-ink">
          “{review.text}”
        </blockquote>
      </div>
      <figcaption className="mt-7 pt-5 border-t border-brand-ink/10">
        <span className="block font-medium text-brand-ink">{review.name}</span>
        <span className="text-xs uppercase tracking-[0.18em] text-muted-foreground">
          {review.role}
        </span>
      </figcaption>
    </figure>
  );
}
